import React from "react";
import styles from "../../assessmentViewer/FoundationStage/NarrativeAssessmentCardBase.module.css";
import {
  parseNarrativeStrategyBlock,
  splitNarrativeStrategySentences,
} from "./narrativeStrategyUtils";

const NarrativeStrategyCardBase = ({
  markdown = "",
  Icon,
  subtitle = "Strategy direction and execution priorities",
  titleOverride = "",
}) => {
  const parsed = parseNarrativeStrategyBlock(markdown);
  if (!parsed) return null;

  const displayTitle = String(parsed.title || "")
    .replace(/\s+Strategy\s*$/i, "")
    .trim();
  const sentences = splitNarrativeStrategySentences(parsed.body);
  const rows = sentences.length > 0 ? sentences : [];

  return (
    <div className={styles.card}>
      <div className={styles.hero}>
        <div className={styles.heroLeft}>
          {Icon ? (
            <div className={styles.heroIcon} aria-hidden="true">
              <Icon size={18} />
            </div>
          ) : null}
          <div>
            <h4 className={styles.heroTitle}>
              {titleOverride || displayTitle || parsed.title}
            </h4>
          </div>
        </div>
        <p className={styles.heroSubtitle}>{subtitle}</p>
      </div>

      <div className={styles.section}>
        {rows.length > 0 ? (
          rows.map((line, idx) => (
            <div key={`${line}-${idx}`} className={styles.row}>
              <span className={styles.dot} />
              <span>{line}</span>
            </div>
          ))
        ) : (
          <p className={styles.sectionText}>{parsed.body}</p>
        )}
      </div>
    </div>
  );
};

export default NarrativeStrategyCardBase;
